export default class PdfProofResponse {
	Status: string
	Output: string
	Message: string
	ResultUrl: string
	constructor() {
		this.Status = ""
		this.Output = ""
		this.Message = ""
		this.ResultUrl = ""
	}
}
